import I18n from "i18n-js";
// Here we only load the translations for the current scope for security reasons
// and to avoid loading a file too big
I18n.translations = CURRENT_TRANSLATIONS;
I18n.locale = CURRENT_LOCALE;

export const translate = (key, options) => {
  const franchise = FRANCHISE_CODE.toLowerCase();
  let scopedOptions = {
    ...(options || {}),
    scope: franchise,
    defaultValue: I18n.t(key, options)
  };
  return (I18n.t(key, scopedOptions));
};